import { render, staticRenderFns } from "./FormDetailsContainer.vue?vue&type=template&id=10864364"
import script from "./FormDetailsContainer.vue?vue&type=script&lang=js"
export * from "./FormDetailsContainer.vue?vue&type=script&lang=js"
import style0 from "./FormDetailsContainer.vue?vue&type=style&index=0&id=10864364&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports